export default "__VITE_ASSET__CJxJ$$5z__"